import { Divider, Heading, Link, Text } from '@ritualco/jutsu'
import { Clipboard } from 'components/Clipboard'
import { QRCode } from 'components/QRCode'
import { useContent } from 'lib/content/react'

type ShareSectionProps = {
  qrCodeUrl?: string
  url?: string
}

export const ShareSection = ({ qrCodeUrl, url }: ShareSectionProps) => {
  const { formatMessage } = useContent()

  return (
    <>
      {qrCodeUrl && (
        <>
          <Heading
            as="h3"
            fontWeight="medium"
            fontSize="large"
            lineHeight="large"
            pb={3}
          >
            {formatMessage({ id: 'pmportal.restaurantLists.qrCodeTitle' })}
          </Heading>
          <Text
            color="grayscale.secondary"
            fontSize="small"
            lineHeight="small"
            pb={8}
          >
            {/* TODO: replace href with actual link */}
            {formatMessage(
              { id: 'pmportal.restaurantLists.qrCodeDescription' },
              {
                link: text => (
                  <Link href="https://ritual.co/faq" isExternal>
                    {text}
                  </Link>
                ),
              }
            )}
          </Text>
          <QRCode url={qrCodeUrl} />
        </>
      )}
      {qrCodeUrl && url && <Divider mt={6} mb={11} />}
      {url && (
        <>
          <Heading
            as="h3"
            fontWeight="medium"
            fontSize="large"
            lineHeight="large"
            pb={3}
          >
            {formatMessage({ id: 'pmportal.restaurantLists.urlTitle' })}
          </Heading>
          <Text
            color="grayscale.secondary"
            fontSize="small"
            lineHeight="small"
            pb={5}
          >
            {/* TODO: replace href with actual link */}
            {formatMessage(
              { id: 'pmportal.restaurantLists.urlDescription' },
              {
                link: text => (
                  <Link href="https://ritual.co/faq" isExternal>
                    {text}
                  </Link>
                ),
              }
            )}
          </Text>
          <Clipboard value={url} />
        </>
      )}
    </>
  )
}
